export enum WindowEvents {
  BULK_CREATE_PRODUCT_RES_UPDATED = 'bulk-create-product-res-updated',
}
